export const initialAbility = [
  {
    action: 'read',
    subject: 'Auth',
  },
  {
    action: 'read',
    subject: 'PubCalendar',
  },
]

export const _ = undefined
